
import { defineComponent, reactive, toRefs, computed, Ref } from "vue";
import { useLicencaOrgaoService } from "../../../modules/business/licenca/licencaOrgaoBusiness";
import { ImportacaoDocumentoReturn } from "../../../modules/business/veiculo/importacaoVeiculoBusiness";
import { useToast } from "../../../modules/message";

interface ImportacaoPedidoAgesulState {
  importReturn: ImportacaoDocumentoReturn | null;
  imported: boolean;
  stateId: string;
  loadings: Array<Ref<boolean>>;
}

export default defineComponent({
  props: {
    parentLoading: Boolean
  },
  setup(props, { emit }) {
    const state = reactive<ImportacaoPedidoAgesulState>({
      importReturn: null,
      imported: false,
      stateId:
        "state-" +
        Math.random()
          .toString(36)
          .substring(2),
      loadings: []
    });

    const stateLoading = computed(() => {
      return state.loadings.length !== 0 || props.parentLoading;
    });

    const closeScreen = () => {
      emit("after-import", state.imported);
    };

    const fileInput = (suffix: string): HTMLInputElement | null => {
      return document.querySelector(
        "#" + state.stateId + suffix
      ) as HTMLInputElement;
    };

    const clearFiles = () => {
      [
        fileInput("_pedidoAgesul"),
        fileInput("_boleto"),
        fileInput("_comprovante")
      ].forEach((file) => {
        if (file) {
          file.value = "";
        }
      });
    };

    const submitSave = () => {
      state.importReturn = null;
      const pedidoAgesul = fileInput("_pedidoAgesul");
      const comprovante = fileInput("_comprovante");
      if (
        !pedidoAgesul ||
        !pedidoAgesul.files ||
        pedidoAgesul.files.length === 0
      ) {
        useToast().warning("É necessário o Pedido AGESUL.");
        return;
      }
      if (
        !comprovante ||
        !comprovante.files ||
        comprovante.files.length === 0
      ) {
        useToast().warning("É necessário o comprovante de pagamento.");
        return;
      }
      const formData = new FormData();
      formData.append("pedidoAgesul", pedidoAgesul.files[0]);
      formData.append("comprovante", comprovante.files[0]);
      const boleto = fileInput("_boleto");
      if (boleto && boleto.files && boleto.files.length > 0) {
        formData.append("boleto", boleto.files[0]);
      }

      const { importarPedidoAgesul, loading, data } = useLicencaOrgaoService();
      state.loadings.push(loading);
      importarPedidoAgesul(formData)
        .then(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
          clearFiles();
          state.importReturn = data.value;
          if (!state.importReturn) {
            useToast().warning("Não foi possível realizar a importação.");
          } else {
            state.imported = !!state.importReturn.sucesso?.length;
            if (state.importReturn.erros && state.importReturn.erros.length) {
              useToast().warning(
                "Arquivo processado com erros. Verifique o retorno."
              );
            } else {
              useToast().success("Importação realizada com sucesso.");
            }
          }
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    return {
      stateLoading,
      closeScreen,
      submitSave,
      ...toRefs(state)
    };
  }
});
